export default __webpack_public_path__ + "static/media/down-arrow.69f12162.svg";